import { generateFontStyleFromSystem } from "../font-styles";
import { css } from "styled-components";
import { Lazy } from "lib/lazy";

const poppinsFont = "Poppins, BlinkMacSystemFont, Roboto, sans-serif";
const nunitoFont = "Nunito Sans, BlinkMacSystemFont, Roboto, sans-serif";

export const modernFontOverlay = new Lazy(() =>
    generateFontStyleFromSystem({
        AccentHeader: {
            weights: [700, 700, 700, 700, 700, 600, 600],
            fontFamily: poppinsFont,
        },
        AccentSubheader: {
            weights: 600,
            fontFamily: poppinsFont,
        },
        AccentCallout: {
            weights: 500,
            fontFamily: poppinsFont,
        },
        AccentBody: {
            weights: 400,
            fontFamily: poppinsFont,
        },
        Header: {
            weights: [700, 700, 600, 500, 500, 500, 500],
        },
        Subheader: 600,
        Callout: 500,
        Body: 400,
        Caption: {
            weights: 400,
            fontFamily: poppinsFont,
        },
        Tag: {
            weights: 700,
            sizes: [22, 18, 15, 13, 12, 10, 9],
            css: css`
                text-transform: uppercase;
            `,
        },
        defaultFontFamily: nunitoFont,
        defaultFontSizes: [34, 24, 20, 16, 14, 12, 10],
        defaultLineHeights: [37, 29, 24, 19, 17, 17, 14],
        load: ["Poppins:400,500,600,700", "Nunito Sans:400,500,600,700"],
    })
);
